import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.267 6.467V6.7c0 .898-.735 1.633-1.634 1.633H4.467A1.64 1.64 0 0 1 2.833 6.7v-.233c0-.899.735-1.634 1.634-1.634h8.166c.899 0 1.634.735 1.634 1.634m4.9 6.533c0 .898-.735 1.633-1.634 1.633H4.467A1.64 1.64 0 0 1 2.833 13c0-.898.735-1.633 1.634-1.633h13.066c.899 0 1.634.735 1.634 1.633m-9.334 6.533c0 .899-.735 1.634-1.633 1.634H4.467a1.64 1.64 0 0 1-1.634-1.634c0-.898.735-1.633 1.634-1.633H8.2c.898 0 1.633.735 1.633 1.633" }, null, -1)
  ]))]))
}
export default { render: render }